export const readFileAsDataUrl = (file: Blob) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
        return;
      }

      reject(new Error('文件读取失败'));
    };

    reader.onerror = () => {
      reject(reader.error || new Error('文件读取失败'));
    };

    reader.readAsDataURL(file);
  });
